<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-card class="team-section-card pa-4 pa-md-6">
                <div class="team-section-header">
                    <span class="team-section-kicker">Προγραμμα</span>
                    <h2 class="team-section-title">Προγραμμα Ομαδας</h2>
                </div>
                <div class="team-schedule-list">
                    <div v-for="match in schedule" :key="String(match.id || `${match.date}-${match.home}-${match.away}`)" class="team-schedule-item">
                        <v-card outlined class="team-schedule-card">
                            <v-card-text>
                                <div class="team-schedule-top-row">
                                    <div class="team-schedule-round">{{ match.round }}</div>
                                    <div class="team-schedule-date">{{ match.date }}</div>
                                    <div class="team-schedule-meta">{{ match.time }}</div>
                                </div>
                                <div class="team-schedule-title team-schedule-bottom-row">
                                    <div class="schedule-team">
                                        <img v-if="match.homeLogo" :src="match.homeLogo" :alt="match.home" class="schedule-team-logo">
                                        <span>{{ match.home }}</span>
                                    </div>
                                    <span class="schedule-score">{{ match.homeScore }} - {{ match.awayScore }}</span>
                                    <div class="schedule-team schedule-team-away">
                                        <img v-if="match.awayLogo" :src="match.awayLogo" :alt="match.away" class="schedule-team-logo">
                                        <span>{{ match.away }}</span>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'TeamScheduleSection',
        props: {
            schedule: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style scoped>
.team-section-card {
    background: rgba(255, 255, 255, 0.96);
}

.team-section-header {
    margin-bottom: 20px;
    text-align: left;
}

.team-section-kicker {
    display: inline-block;
    margin-bottom: 6px;
    color: #ac2f37;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.team-section-title {
    margin: 0;
    color: #223152;
    font-size: clamp(1.5rem, 2.4vw, 2.2rem);
    line-height: 1.15;
    text-transform: none !important;
}

.team-schedule-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
}

.team-schedule-item {
    width: 100%;
    max-width: 760px;
}

.team-schedule-card {
    width: 100%;
}

.team-schedule-title {
    color: #223152;
    font-size: 1.05rem;
    font-weight: 700;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
}

.team-schedule-round {
    color: #ac2f37;
    font-weight: 700;
}

.team-schedule-meta,
.team-schedule-date {
    color: #4b5970;
}

.team-schedule-top-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    margin-bottom: 8px;
    justify-content: center;
    text-align: center;
}

.schedule-team {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    white-space: nowrap;
}

.schedule-team-away {
    justify-content: flex-start;
}

.schedule-team-logo {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.schedule-team span {
    overflow: hidden;
    text-overflow: ellipsis;
}

.schedule-score {
    font-weight: 800;
    color: #1f2b45;
}

.team-schedule-bottom-row {
    margin-top: 2px;
}

@media only screen and (max-width: 600px) {
    .team-schedule-title {
        flex-direction: column;
        gap: 4px;
        white-space: normal;
    }

    .schedule-team,
    .schedule-team-away {
        justify-content: center;
    }

    .schedule-score {
        width: 100%;
        text-align: center;
    }
}
</style>
